import React from 'react';
import { Box } from '@mui/material';
import ChatInterface from './ChatInterface';

const SimpleFullPageChat: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        bgcolor: '#1a1a2e',
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        margin: 0,
        padding: 0,
      }}
    >
      <ChatInterface fullPage={true} />
    </Box>
  );
};

export default SimpleFullPageChat;
